import * as Yup from "yup";

export const validationSchema = Yup.object().shape({
  name: Yup.string().required("Holiday name is required"),
  type: Yup.string().required("Type is required"),
  country: Yup.array()
    .of(Yup.string())
    .min(1, "At least one country is required")
    .required("Countries are required"),
  date: Yup.date().nullable().required("Date is required"),
  years: Yup.array()
    .of(Yup.string())
    .min(1, "At least one year is required")
    .required("Years are required"),
  fixed: Yup.boolean().required("Fixed/Variable status is required"),
});
